import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionService } from '../../../../services/connection-service';
import { Table } from '@cureskin/api-client';

@Component({
    selector: 'sales-regimen-variant-no-order',
    imports: [CommonModule],
    templateUrl: './sales-regimen-variant-no-order.html',
    styleUrl: './sales-regimen-variant-no-order.scss'
})
export class SalesRegimenVariantNoOrderComponent {
  @Input('user') user: Table.User;
  regimenClasses: Array<string> = [];
  regimens: any[] = [];
  selectedRegimenClass: string = '';
  regimenData: Array<{
    price: number;
    noOfProducts: number;
    products: string;
  }> = [];

constructor(private conn: ConnectionService) {}

async ngOnInit(): Promise<void> {
  await this.getUserRegimens();
  if (!this.regimens?.length) return;
  this.regimenClasses = this.regimens.map((regimen) => regimen.get('class'));
  this.selectedRegimenClass = this.regimenClasses[0];
  this.updateRegimenVariantData(this.selectedRegimenClass);
}

async getUserRegimens(): Promise<void> {
    this.regimens = await this.conn.findRegimens({
        where: {
            forUser: this.user,
            type: 'PERSONALIZED',
        }
    });
}

updateRegimenVariantData(selectedRegimenClass: string): void {
  const regimen = this.regimens.find((r: any) => r.get('class') === selectedRegimenClass);
  if (!regimen) return;
  const variants = regimen.get('variants');
  if (!variants) return;
  this.regimenData = variants.map((variant: any) => ({
    price: variant.fixedPrice,
    noOfProducts: variant.products.length,
    products: variant.products.map((product: any) => product.get('title')).join(', '),
  }));
}

onChangeRegimenClass(regimenClass: string): void {
  this.selectedRegimenClass = regimenClass;
  this.updateRegimenVariantData(this.selectedRegimenClass);
}
}

